"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatColumnStyleViewItems = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const FormatColumnStyleWizardSection_1 = require("../../../View/FormatColumn/Wizard/FormatColumnStyleWizardSection");
const getFormatColumnStyleViewItems = (formatColumn, api) => {
    return React.createElement(rebass_1.Box, { mt: 2 }, (0, FormatColumnStyleWizardSection_1.renderFormatColumnStyleSummary)(formatColumn, api));
};
exports.getFormatColumnStyleViewItems = getFormatColumnStyleViewItems;
